import type { ReactElement, ForwardedRef } from 'react';

import {
  useImperativeHandle,
  forwardRef,
  useEffect,
  useState,
  useRef,
} from 'react';
import { createPortal } from 'react-dom';

export interface PortalRefType {
  close: () => void;
}
export interface PortalProps {
  children: ReactElement;
}

const Portal = forwardRef(
  ({ children }: PortalProps, ref: ForwardedRef<PortalRefType>) => {
    const portalContainerRef = useRef<Element | null>(null);
    const [isMounted, setIsMounted] = useState(false);

    useEffect(() => {
      if (!portalContainerRef.current) {
        portalContainerRef.current = document.getElementById('root');
      }
      setIsMounted(true);

      return () => {
        setIsMounted(false);
      };
    }, [setIsMounted]);

    useImperativeHandle(ref, () => {
      return {
        close: () => {
          if (portalContainerRef.current?.lastChild)
            portalContainerRef.current?.removeChild(
              portalContainerRef.current.lastChild,
            );
        },
      };
    });

    return isMounted && portalContainerRef.current
      ? createPortal(children, portalContainerRef.current)
      : null;
  },
);

Portal.displayName = 'Portal';
export default Portal;
